import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ade6ba3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity-buttons" }
const _hoisted_2 = { class: "items-in-line" }
const _hoisted_3 = {
  key: 0,
  class: "mt--13"
}

import { FileType, ResultCardType } from '@/types';
import { CompareIcon, SaveDocsBtn } from '@/components/Cards/CardsComponents';
import PhoneButton from '@/components/PhoneButton/PhoneButton.vue';
import { ShareBtn } from '@/components';
import { useChatStore } from '@/store/modules/chat';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityButtons',
  props: {
    offerCard: {},
    phone: {},
    docs: {},
    isCompare: { type: Boolean },
    isFavorite: { type: Boolean },
    withFeedBack: { type: Boolean, default: true }
  },
  emits: ['changeIsFavorite'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ShareBtn), {
        "font-size": "20",
        height: "28",
        width: "28"
      }),
      (_ctx.docs?.length)
        ? (_openBlock(), _createBlock(_unref(SaveDocsBtn), {
            key: 0,
            docs: _ctx.docs,
            class: "scale"
          }, null, 8, ["docs"]))
        : _createCommentVNode("", true),
      (_ctx.offerCard)
        ? (_openBlock(), _createBlock(_unref(CompareIcon), {
            key: 1,
            card: _ctx.offerCard,
            "with-border": ""
          }, null, 8, ["card"]))
        : _createCommentVNode("", true),
      (_ctx.offerCard)
        ? (_openBlock(), _createBlock(_component_base_button, {
            key: 2,
            class: "scale",
            icon: "",
            "style-type": "border",
            withoutActive: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeIsFavorite')))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_base_icon, {
                color: _ctx.isFavorite ? '#EA1F1F' : '#614B40FF',
                "font-size": "20",
                height: "22",
                name: "favorite",
                width: "22"
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.withFeedBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(PhoneButton, {
            phone: _ctx.phone,
            height: "36"
          }, null, 8, ["phone"]),
          (_ctx.offerCard)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                "all-block-width": "",
                class: "mt--13",
                height: "36",
                "style-type": "coloredBorder",
                text: "Написать",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useChatStore)().openMiniMessenger(_ctx.offerCard)))
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})